var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromotions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3667 21.499C8.48983 21.4842 6.46425 21.368 5.18311 21.2607C3.86762 21.1508 2.82177 20.1643 2.69287 18.8281C2.60251 17.8899 2.51793 16.5493 2.50146 14.7441H11.3667V21.499ZM21.4976 14.7441C21.4815 16.5493 21.3965 17.8899 21.3062 18.8281C21.1777 20.1643 20.1315 21.1508 18.8159 21.2607C17.5348 21.368 15.5097 21.4842 12.6333 21.499V14.7441H21.4976ZM16.2231 2.49902C18.0636 2.49917 19.3901 3.93019 19.3901 5.66602C19.3908 6.12603 19.2907 6.58074 19.0972 6.99805C20.2785 7.21521 21.1867 8.1549 21.3062 9.39453C21.3965 10.3327 21.4815 11.6728 21.4976 13.4775H12.6333V7.99023C12.2112 7.98799 11.7888 7.98799 11.3667 7.99023V13.4775H2.50146C2.51794 11.6725 2.60251 10.3323 2.69287 9.39453C2.81236 8.15408 3.72113 7.21523 4.90283 6.99805C4.70943 6.58071 4.6101 6.12599 4.61084 5.66602C4.61084 3.93011 5.93719 2.49902 7.77783 2.49902C9.30379 2.4991 10.5216 3.38746 11.3276 4.36621C11.5882 4.68289 11.8139 5.01688 12.0005 5.34961C12.1866 5.01703 12.412 4.68277 12.6724 4.36621C13.4789 3.38741 14.6971 2.49902 16.2231 2.49902ZM7.77783 3.76562C6.66264 3.76562 5.87744 4.60361 5.87744 5.66602C5.87667 6.10901 6.03154 6.53842 6.31494 6.87891C7.53148 6.8029 9.15803 6.73728 11.2368 6.72461C11.2008 6.61943 11.1601 6.51502 11.1157 6.41309C10.9184 5.9663 10.6608 5.54871 10.3501 5.17188C9.67832 4.35612 8.78527 3.7657 7.77783 3.76562ZM16.2231 3.76562C15.2156 3.76562 14.3223 4.35607 13.6509 5.17188C13.34 5.54883 13.0816 5.96614 12.8843 6.41309C12.837 6.52287 12.7975 6.62749 12.7642 6.72461C14.8427 6.73771 16.47 6.80291 17.686 6.87891C17.9694 6.53844 18.1233 6.10897 18.1226 5.66602C18.1226 4.6037 17.3382 3.76576 16.2231 3.76562Z",
    fill: "url(#paint0_linear_39_28431)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39_28431",
    x1: 11.9995,
    y1: 2.49902,
    x2: 11.9995,
    y2: 21.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2B62E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#934600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotions);
export default __webpack_public_path__ + "static/media/promotions.b2154db0f6b980040720bfb5d43e8376.svg";
export { ForwardRef as ReactComponent };